<template>
    <div class="columns is-multiline">
        <div class="column is-full">
            <b-table
            :data="sections.length ? sections : []"
            :loading="loadingSections"
            :hoverable="true"
            >
                <template slot-scope="props">
                    <b-table-column width="40" numeric label="ID">
                        <p>{{props.row.id}}</p>
                    </b-table-column>
                    <b-table-column field="timestamp" label="Titulo" centered>
                        <b-input
                        v-model="props.row.title"
                        @input="updateSection(props.row)">
                        </b-input>
                    </b-table-column>
                    <b-table-column>
                        <a class="has-text-danger" @click="deleteSection(props.row.id)"><b-icon icon="trash"></b-icon></a>
                    </b-table-column>
                </template>
            </b-table>
        </div>

        <div class="column is-full has-text-centered">
            <b-button
            rounded
            type="is-primary"
            @click="addSectionModal=true"
            >
                <b-icon icon="plus" size="is-small"></b-icon>
                Agregar una seccion.
            </b-button>
        </div>

        <b-modal :active.sync="addSectionModal" scroll="keep">
            <div class="modal-card" style="width: auto">
                
                <div class="modal-card-body">
                    <div class="columns is-multiline">
                        <div class="column has-text-centered is-full">
                            <p class="modal-card-title m-b-10">Agrega nuevas secciones al blog.</p>
                        </div>
                        <div class="column is-half">
                            <div v-for="(sec, i) in newSections" class="m-b-10" :key="i">
                                <b-field 
                                label="Titulo"
                                label-position="on-border"
                                grouped
                                expanded>
                                    <b-input
                                    v-model="sec.title">
                                    </b-input>
                                    <p class="control">
                                        <a class="has-text-danger"
                                        @click="deleteNewSection(i)">
                                            <b-icon icon="trash" size="is-small"></b-icon>
                                        </a>
                                    </p>
                                </b-field>
                            </div>
                        </div>
                        <div class="column is-full">
                            <b-button 
                                @click="addNewSectionLine"
                                type="is-text">
                                Agregar linea
                            </b-button>
                        </div>
                        <div class="column is-full has-text-centered">
                            <b-button
                            type="is-primary"
                            rounded
                            @click="createSections"
                            >
                                <b-icon icon="paper-plane" size="is-small"></b-icon>
                                Crear secciones
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { patchHandler, getHandler, postHandler, debounce, deleteHandler } from '../../../../services/http';

export default {
    props:{
        sections:{
            type:Array,
            default: new Array([])
        },
        sectionEdit:{
            type:String,
            default:""
        },
        loadingSections:{
            type:Boolean,
            default:false
        },
        sectionListCreate:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            addSectionModal:false,
            newSections:[
                {title:''}
            ]
        }
    },
    methods:{
        updateSection:debounce(
                async function(section){
                var error = {
                    resource:'notify'
                }
                var success = {
                    resource:'notify'
                }
                console.log("Update atempt", section)
                var url = this.sectionEdit.replace('0000', section.id)
                var resp = await patchHandler(url, {title:section.title}, {error, success})
                this.$emit("refreshList")
            },
            700
        ),
        async createSections(){
            var error = {
                resource:'notify'
            }
            var success = {
                resource:'notify'
            }
            var response = await postHandler(this.sectionListCreate, this.newSections, {error, success})
            this.newSections = [{title:''},]
            this.addSectionModal = false
            this.$emit("refreshList")
        },
        async deleteSection(id){
            var error = {
                resource:'notify'
            }
            var success = {
                resource:'notify'
            }
            var url = this.sectionEdit.replace('0000', id)
            var resp = await deleteHandler(url, {error, success})
            this.$emit("refreshList")
        },
        addNewSectionLine(){
            this.newSections.push({title:''})
        },
        deleteNewSection(i){
            this.newSections.splice(i, 1)
        }
    }
}
</script>


<style lang="scss">
.modal-card-body{
    border-radius:50px;

}
</style>